import React, { Fragment } from 'react';
import Bugsnag from '@bugsnag/js';
import { NotifiableError } from '@bugsnag/core';
import BugsnagPluginReact, {
  BugsnagErrorBoundary,
} from '@bugsnag/plugin-react';

const getIsBugsnagEnabled = () => {
  return (
    typeof window !== 'undefined' &&
    process.env.NEXT_PUBLIC_RELEASE_STAGE !== 'development'
  );
};

export const start = () => {
  let ErrorBoundary: BugsnagErrorBoundary = Fragment;

  if (getIsBugsnagEnabled()) {
    Bugsnag.start({
      apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY || '',
      appVersion: process.env.NEXT_PUBLIC_APP_VERSION || '',
      releaseStage: process.env.NEXT_PUBLIC_RELEASE_STAGE || '',
      plugins: [new BugsnagPluginReact()],
    });

    ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);
  }

  return ErrorBoundary;
};

export const notify = (error: NotifiableError) => {
  if (getIsBugsnagEnabled()) {
    Bugsnag.notify(error);
    return;
  }

  console.error(error);
};
